import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { selectAuthUser, selectAuthUserProfileImageUrl } from '../../auth/auth.selectors';
import { COUNTRIES } from '../../../global/countries';
import { User } from '../../administration/user/user.models';
import { UpdateUserProfileImageAction, RemoveLogedUserProfileImageAction } from '../../auth/auth.actions';

import { CommonConstants } from '../../../global/interfaces';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { switchMap, map, catchError } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { WindowResizeService } from '../../../global/window-resize.service';
import { Actions } from 'atlas-cdk';
import { ToastService } from '../../../shared/toaster_/toaster_.service';

@Component({
  standalone: false,
  selector: 'dsp-details',
  templateUrl: 'details.component.html',
  styleUrls: ['details.component.scss']
})
export class DetailsComponent implements OnInit, OnDestroy {
  public user$: Observable<User | undefined>;
  public country$: BehaviorSubject<{ name: string; value: string } | null> =
    new BehaviorSubject<{ name: string; value: string } | null>(null);
  public countries = COUNTRIES;

  public country = '';
  public message: string;
  public userId: string;
  public profileImageId: string;
  public profileImageUrl$: BehaviorSubject<{} | null> = new BehaviorSubject<{} | null>(null);
  public profileImageDataUrl$: Observable<any> = new Observable<any>(null);
  public loading = true;
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly subscription: Subscription = new Subscription();
  public imageUrl: any;
  public imageLoadFailed = false;


  public constructor(
    private readonly store: Store<AppState>,
    private readonly httpClient: HttpClient,
    private readonly domSanitizer: DomSanitizer,
    private readonly resize: WindowResizeService,
    private readonly _toasterService: ToastService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));

  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeIsMobile());

    this.user$.subscribe(user => {
      if (user && user.org) {
        this.userId = user._id;
        this.profileImageId = user.profileImageId;
        this.country = COUNTRIES[user.org.country].value;
        this.country$.next(COUNTRIES[user.org.country]);
      }
    });

    // this.store.pipe(select(selectAuthUserProfileImageUrl))
    //   .subscribe(profileImageUrl => {
    //     this.loading = true;
    //     // this.profileImageDataUrl$ = this.loadImage(profileImageUrl);
    //   });
    this.profileImageDataUrl$ = this.store.pipe(
      select(selectAuthUserProfileImageUrl),
      switchMap(profileImageUrl => {
        return profileImageUrl ? this.loadImage(profileImageUrl) : of(null);
      })
    );
    this.profileImageDataUrl$.subscribe(dataUrl => {
      this.imageUrl = dataUrl;
      this.imageLoadFailed = !dataUrl;
      this.cdr.markForCheck();
    });

  }

  public onReset(): void {
  }

  public setProfileImage(event): void {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].name.match(/\.(png|jpeg|jpg)$/i) == null) {
        //this.store.dispatch(new AddErrorToastAction(CommonConstants.profileImageType));
        return this._toasterService.launchAlertError(CommonConstants.profileImageType, Actions.error);
      }
      if (event.target.files[0].size > 1000000) {
        //this.store.dispatch(new AddErrorToastAction(CommonConstants.profileImageSize));
        return this._toasterService.launchAlertError(CommonConstants.profileImageSize, Actions.error);
      }
      const payload: FormData = new FormData();
      payload.append('file', event.target.files[0]);
      payload.append('_id', this.userId);
      payload.append('profileImageId', `xx${this.userId}fake`);
      this.store.dispatch(new UpdateUserProfileImageAction(payload));
    }
  }

  onLoad() {
    this.loading = false;
  }
  onLoadError() {
    this.loading = true;
  }
  public removeImage(): void {
    if (!isNullOrUndefined(this.profileImageId)) {
      const payload: FormData = new FormData();
      payload.append('file', null);
      payload.append('_id', this.userId);
      payload.append('profileImageId', this.profileImageId);
      this.store.dispatch(new UpdateUserProfileImageAction(payload));
    } else {
      //this.store.dispatch(new AddErrorToastAction(CommonConstants.noImageAvailable));
      return this._toasterService.launchAlertError(CommonConstants.noImageAvailable, Actions.error);
    }
  }

  private loadImage(url: any): Observable<any> {
    if (typeof url === 'string' && url.trim() !== '') {
      return this.httpClient
        .get(url, { responseType: 'blob', withCredentials: true })
        .pipe(
          map(blob => {
            if (blob && blob.size > 0) {
              const blobUrl = URL.createObjectURL(blob);
              return blobUrl;
            } else {
              return null;
            }
          }),
          catchError(err => {
            return of(null);
          })
        );
    } else {
      return of(null);
    }
  }
  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
